import { IconChevronRight12 } from '@cian/ui-kit/icons';
import * as React from 'react';

import styles from './MagazineItem.css';
import { tackMagazineItemClick } from '../../tracking/trackMagazineItemClick';
import { TMagazineModel } from '../../types';

export function MagazineItem({ img, title, url }: TMagazineModel) {
  return (
    <a
      href={url}
      className={styles['container']}
      style={{ backgroundImage: `url(${img}` }}
      target="_blank"
      onClick={tackMagazineItemClick(url)}
    >
      <div className={styles['title']}>
        <span>
          {title}&nbsp;
          <IconChevronRight12 color="white_100" />
        </span>
      </div>
    </a>
  );
}
